(function () {
  const initSliders = (section) => {
    const swiperEls = section.querySelectorAll(".products-tabs__layout");

    swiperEls.forEach((swiperEl, index) => initSlider(section, swiperEl, index));
  };

  const initSlider = (section, swiperEl, index) => {
    {
      const swiperWrapper = swiperEl.querySelector(".products-tabs__slider");
      const slides = swiperEl.querySelectorAll(".products-tabs__item");

      if (!swiperWrapper || !slides || !slides.length) return;

      swiperEl.classList.add("swiper");
      swiperWrapper.classList.add("swiper-wrapper");
      slides.forEach((slide) => slide.classList.add("swiper-slide"));

      const nextBtns = section.querySelectorAll(
        `.products-tabs__navigation--${
          index + 1
        } .products-tabs__navigation-button-next`
      );
      const prevBtns = section.querySelectorAll(
        `.products-tabs__navigation--${
          index + 1
        } .products-tabs__navigation-button-prev`
      );

      const columns = Number(
        section.querySelector(".products-tabs").dataset.columns
      );
      const columnsConfig = {
        6: {
          576: { slidesPerView: 2 },
          750: { slidesPerView: 3 },
          990: { slidesPerView: 4 },
          1360: { slidesPerView: 6 },
        },
        5: {
          576: { slidesPerView: 2 },
          750: { slidesPerView: 3 },
          1360: { slidesPerView: 5 },
        },
        4: {
          576: { slidesPerView: 2 },
          1200: { slidesPerView: 4 },
        },
        3: {
          576: { slidesPerView: 2 },
          750: { slidesPerView: 3 },
        },
        2: {
          576: { slidesPerView: 2 },
        },
        1: {
          576: { slidesPerView: 1 },
        },
      };

      sliderSettings = {
        slidesPerView: Number(
          section.querySelector(".products-tabs").dataset.mobileColumn
        ),
        spaceBetween: 8,
        speed: 800,
        allowTouchMove: true,
        mousewheel: {
          forceToAxis: true,
        },
        navigation: {
          nextEl: Array.from(nextBtns),
          prevEl: Array.from(prevBtns),
          disabledClass: "swiper-button-disabled",
        },
        breakpoints: columnsConfig[columns],
      };

      new Swiper(swiperEl, sliderSettings);
    }
  };

  // yc-lazy-tabs: tabs after the first ship empty; their products are fetched once, on first open,
  // from this section rendered alone (which always contains every tab), then the slider is rebuilt.
  let lazyRequest = null;
  const loadAllTabs = (url) => {
    if (!lazyRequest) {
      lazyRequest = fetch(url)
        .then((r) => (r.ok ? r.text() : Promise.reject(r.status)))
        .then((html) => new DOMParser().parseFromString(html, "text/html"))
        .catch((e) => { lazyRequest = null; throw e; });
    }
    return lazyRequest;
  };
  const fillLazyTab = (section, layoutEl) => {
    const box = section.querySelector(".products-tabs");
    const url = box && box.dataset.ycLazyUrl;
    if (!url || !layoutEl.querySelector("[data-yc-lazy-pending]") || layoutEl.classList.contains("yc-lazy-loading")) return;
    layoutEl.classList.add("yc-lazy-loading");
    loadAllTabs(url)
      .then((doc) => {
        const tabId = layoutEl.dataset.productsTabId;
        const src = doc.querySelector(`.products-tabs__layout[data-products-tab-id="${tabId}"] .products-tabs__list`);
        const list = layoutEl.querySelector(".products-tabs__list");
        if (!src || !list || !layoutEl.querySelector("[data-yc-lazy-pending]")) return;
        if (layoutEl.swiper) layoutEl.swiper.destroy(true, true);
        layoutEl.classList.remove("swiper");
        list.classList.remove("swiper-wrapper");
        list.innerHTML = src.innerHTML;
        // The theme's fade-in (global.js addAnimation) only observes cards present at page load, and on
        // desktop .column-animation sits at opacity 0 until it gets .animate, so injected cards stay invisible.
        list.querySelectorAll(".column-animation").forEach((el) => el.classList.add("animate"));
        const layouts = Array.from(section.querySelectorAll(".products-tabs__layout"));
        initSlider(section, layoutEl, layouts.indexOf(layoutEl));
      })
      .catch(() => {})
      .finally(() => layoutEl.classList.remove("yc-lazy-loading"));
  };

  const toggleTab = (section) => {
    const tabsEls = section.querySelectorAll(".products-tabs__tab");
    const productsEls = section.querySelectorAll(".products-tabs__layout");

    const tabBar = section.querySelector(".products-tabs__tabs");
    const box = section.querySelector(".products-tabs");
    if (tabBar && box && box.dataset.ycLazyUrl) {
      const warm = () => loadAllTabs(box.dataset.ycLazyUrl).catch(() => {});
      ["pointerenter", "touchstart", "focusin"].forEach((ev) => tabBar.addEventListener(ev, warm, { once: true, passive: true }));
    }

    // Tabs pattern: Left/Right (and Home/End) move between tabs and select them.
    const tabList = Array.from(tabsEls);
    tabList.forEach((tab, i) => {
      tab.addEventListener("keydown", (e) => {
        let n = null;
        if (e.key === "ArrowRight") n = (i + 1) % tabList.length;
        else if (e.key === "ArrowLeft") n = (i - 1 + tabList.length) % tabList.length;
        else if (e.key === "Home") n = 0;
        else if (e.key === "End") n = tabList.length - 1;
        if (n === null) return;
        e.preventDefault();
        tabList[n].focus();
        tabList[n].click();
      });
    });

    tabsEls.forEach((tab) => {
      tab.addEventListener("click", (event) => {
        event.preventDefault();
        const tabId = tab.dataset.productsTabId;
        if (tab.classList.contains("active")) {
          // A lazy tab whose fetch failed stays empty; tapping it again retries.
          const current = section.querySelector(`.products-tabs__layout[data-products-tab-id="${tabId}"]`);
          if (current) fillLazyTab(section, current);
          return;
        }

        tabsEls.forEach((el) => {
          el.classList.remove("active");
          el.setAttribute("aria-selected", "false");
          el.setAttribute("tabindex", "-1");
        });

        productsEls.forEach((el) => {
          el.classList.remove("active");
        });

        const productsActiveEl = section.querySelector(
          `.products-tabs__layout[data-products-tab-id="${tabId}"]`
        );
        tab.classList.add("active");
        tab.setAttribute("aria-selected", "true");
        tab.setAttribute("tabindex", "0");
        productsActiveEl.classList.add("active");
        fillLazyTab(section, productsActiveEl);

        section
          .querySelectorAll(".products-tabs__navigation")
          .forEach((navigation) => {
            navigation.classList.remove("active");
          });

        section
          .querySelectorAll(
            `.products-tabs__navigation[data-tab-id="${tabId}"]`
          )
          .forEach((navigation) => {
            navigation.classList.add("active");
          });
      });
    });
  };

  const initProductsTabs = (section) => {
    if (!section || !section?.classList.contains("products-tabs-section")) {
      return;
    }

    initSliders(section);
    toggleTab(section);
  };

  initProductsTabs(document.currentScript.parentElement);

  document.addEventListener("shopify:section:load", function (event) {
    initProductsTabs(event.target);
  });
})();
